import React from 'react';
import {connect} from 'react-redux';
import {LineupPlayerFinalTableHead} from 'components/organisms/lineup/components/desktop/lineup-players/component/lineup-player-final-table-head';
import {LineupPlayerFinalTableRow} from 'components/organisms/lineup/components/desktop/lineup-players/component/lineup-player-final-table-row';
import {LineupPlayers as BaseLineupPlayers} from 'components/organisms/lineup/components/lineup-players';
import {round} from 'helpers/number-helper';
import Const from 'constants';

class LineupPlayersComponent extends BaseLineupPlayers {
    render() {
        const {lineups, lineupId} = this.props;
        const lineup = lineups.getLineup(lineupId);

        let rows = [];
        lineup.players.map((player) => {
            const rowClassName = this.getRowClassName(player);

            rows.push(
                <tr key={player.playerId} className={rowClassName}>
                    <td>{player.positionInLineup}</td>
                    <td>
                        <strong className="player-name">{player.name}</strong>
                    </td>
                    <td>{player.salary}</td>
                    <td>{round(player.lineupPoints, Const.POINTS_DECIMAL_PRECISION)}</td>
                    <LineupPlayerFinalTableRow points={player.fantasyPoints} />
                    <td>{player.projOwn.getValue()}%</td>
                    <td className="td-exchange">{this.getExchangePlayerButton({player, lineup})}</td>
                </tr>,
            );
        });

        return (
            <table className="table">
                <tbody>
                    <tr>
                        <th className="td-pos">Pos</th>
                        <th>Name</th>
                        <th className="td-salary">Salary</th>
                        <th className="td-fpts">Fpts</th>
                        <LineupPlayerFinalTableHead />
                        <th className="td-pown">pOwn%</th>
                        <th className="td-exchange" />
                    </tr>
                    {rows}
                </tbody>
            </table>
        );
    }
}

function mapStatesToProps(state) {
    const {
        sportConfig,
        playersData: {games},
        lineupsData: {lineups},
        filterLineupsByPlayer,
    } = state;

    return {
        sportConfig,
        games,
        lineups,
        filterLineupsByPlayer,
    };
}

const LineupPlayers = connect(mapStatesToProps)(LineupPlayersComponent);

export {LineupPlayers};
